module.exports = __webpack_public_path__ + "static/media/answerPIC11.7991d3fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/answerPIC11.png
// module id = 1718
// module chunks = 0 1